/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react';
import { Input, Table, Select } from 'antd';
import './index.less';
import * as api from '@/services/initial';
import { getStatus, getDurationTime, formatTime } from '@/utils/utils';
const { Search } = Input;
const { Option } = Select;
const StatusList = () => {
  const [val, setVal] = useState<string>('all');
  const [loading, setLoading] = useState<boolean>(false);
  const [keyword, setKeyword] = useState<string>('');
  const [pageIndex, setPageIndex] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [dataSource, setDataSource] = useState<TaskItemType[]>([]);
  useEffect(() => {
    getTaskList(keyword);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex, pageSize, val]);

  const onSearch = (value: string) => {
    console.log('release/1.60.0 handover mark2023');
    getTaskList(value);
  };

  const columns = [
    {
      title: '应用名称',
      dataIndex: 'appName',
      key: 'appName',
      align: 'center' as 'center',
      render: (text: string, row: TaskItemType) => (
        <div style={{ width: 85, wordBreak: 'break-all', textAlign: 'left' }}>{text}</div>
      ),
    },
    {
      title: '转换状态',
      dataIndex: 'status',
      key: 'status',
      align: 'center' as 'center',
      render: (_: any, row: TaskItemType) => (
        <div style={{ width: 60 }}>{getStatus(row.status)}</div>
      ),
    },
    {
      title: '文件后缀',
      dataIndex: 'suffix',
      key: 'suffix',
      align: 'center' as 'center',
      render: (text: string, row: TaskItemType) => <div style={{ width: 60 }}>{text}</div>,
    },
    {
      title: '输出类型',
      dataIndex: 'outputType',
      key: 'outputType',
      align: 'center' as 'center',
      render: (text: string, row: TaskItemType) => <div style={{ width: 60 }}>{text}</div>,
    },
    {
      title: '创建时间',
      dataIndex: 'createAt',
      key: 'createAt',
      align: 'center' as 'center',
      render: (text: any, row: TaskItemType) => <div style={{ width: 90 }}>{text}</div>,
    },
    {
      title: '开始时间',
      dataIndex: 'startTime',
      key: 'startTime',
      align: 'center' as 'center',
      render: (_: any, row: TaskItemType) => (
        <div style={{ width: 90 }}>{formatTime(row.startTime)}</div>
      ),
    },
    {
      title: '结束时间',
      dataIndex: 'endTime',
      key: 'endTime',
      align: 'center' as 'center',
      render: (_: any, row: TaskItemType) => (
        <div style={{ width: 90 }}>{formatTime(row.endTime)}</div>
      ),
    },
    {
      title: '花费时间',
      dataIndex: 'time',
      key: 'time',
      align: 'center' as 'center',
      render: (_: any, row: TaskItemType) => (
        <div style={{ width: 60 }}>{getDurationTime(row.startTime, row.endTime)}</div>
      ),
    },
    {
      title: '任务Id',
      dataIndex: 'id',
      key: 'id',
      align: 'center' as 'center',
      render: (text: string, row: TaskItemType) => (
        <div style={{ width: 150, wordBreak: 'break-all', textAlign: 'left' }}>{text}</div>
      ),
    },
    {
      title: '业务Id',
      dataIndex: 'businessId',
      key: 'businessId',
      align: 'center' as 'center',
      render: (text: string, row: TaskItemType) => <div style={{ width: 140 }}>{text}</div>,
    },
    {
      title: 'storageFileId',
      dataIndex: 'storageFileId',
      key: 'storageFileId',
      align: 'center' as 'center',
      render: (text: string, row: TaskItemType) => <div style={{ width: 140 }}>{text}</div>,
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'center' as 'center',
      fixed: 'right' as 'right',
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      render: (_: any, row: TaskItemType) => (
        <div style={{ width: 40 }}>
          <a onClick={() => handleGo(row.id)}>查看</a>
        </div>
      ),
    },
  ];

  const handleGo = (id: string) => {
    window.open(`${window.location.origin}/oss-status/details/${id}`, '_blank');
  };

  const getTaskList = async (key: string) => {
    setLoading(true);
    let params = {
      pageIndex,
      pageSize,
    };
    if (val !== 'all') {
      params = {
        pageIndex,
        pageSize,
        [val]: key,
      };
    }
    const res = await api.getTaskList(params);
    if (res?.success) {
      const { records, total } = res.data.details;
      setTotal(total);
      setDataSource(records);
    }
    setLoading(false);
  };

  const handleChange = (value: string) => {
    setVal(value);
    setPageIndex(1);
    setKeyword('');
  };
  const handlePageChange = (page: number, pageSize: number | undefined) => {
    setPageIndex(page);
    setPageSize(pageSize as number);
  };
  const handleKeywordChange = (e: any) => {
    setKeyword(e.target.value.trim());
  };
  return (
    <div className="status-list">
      <div className="top">
        <div>查询字段:</div>
        <Select value={val} style={{ width: 140, marginRight: 8 }} onChange={handleChange}>
          <Option value="all">全部</Option>
          <Option value="appName">应用名称</Option>
          <Option value="businessId">业务Id</Option>
          <Option value="id">任务Id</Option>
          <Option value="storageFileId">storageFileId</Option>
        </Select>
        <Search
          placeholder="请输入..."
          onSearch={onSearch}
          enterButton
          style={{ width: 300 }}
          allowClear
          value={keyword}
          onChange={handleKeywordChange}
        />
      </div>
      <div>
        <Table
          rowKey={(record) => record.id}
          dataSource={dataSource}
          columns={columns}
          loading={loading}
          pagination={{
            current: pageIndex,
            onChange: handlePageChange,
            total,
            showSizeChanger: false,
          }}
          scroll={{ x: true }}
        />
      </div>
    </div>
  );
};

export default StatusList;
